<template>
    <div class="">
        <div class="flex jc-sb pt-10 pb-10 pl-15 pr-15">
            <div class="w-60p flex jc-fs">
                <div class="q-no mr-15">{{ index + 1 }}.</div>
                {{ question.stem }}
            </div>
            <div v-if="type == 'edit'" class="flex w-30p jc-fe">
                <div style="color: #F56C6C; margin-right: 4px">*</div>
                <div>分数：</div>
                <div class="flex-1 mr-5">
                    <el-input-number @change="scoreChange" v-model="question.score" :min="1"
                        label="请输入分数"></el-input-number>
                </div>
                <i @click="qUp(question)" class="el-icon-top bor-000 bor-r mr-5" :class="{ 'disable': index == 0 }"></i>
                <i @click="qDown(question)" class="el-icon-bottom bor-000 bor-r mr-5"
                    :class="{ 'disable': index == group.subQuestions.length - 1 }"></i>
                <i class="el-icon-delete" @click="qDel(question)"></i>
            </div>
        </div>
        <div v-if="question.topicType == 1" class="pl-50">
            <div v-for="(a, i) in answer" :key="i" class="mb-15 flex jc-fs">
                <div class="q1"></div>
                {{ a.optionName }}
            </div>
        </div>

        <div v-if="question.topicType == 2" class="pl-50">
            <div v-for="(a, i) in answer" :key="i" class="mb-15 flex jc-fs">
                <div class="q2"></div>
                {{ a.optionName }}
            </div>
        </div>

        <div v-if="question.topicType == 3" class="pl-50">
            <div class="mb-15">正确</div>
            <div class="mb-15">错误</div>
        </div>


        <div v-if="question.topicType == 4" class="pl-50">
            <div v-for="(a, i) in answer" :key="i" class="mb-15 flex jc-fs">
                <div class="q4-1 w-30 bor-e9e9e9 pt-5 pb-5 t-c">{{ i + 1 }}</div>
                <div class="q4-2 w-30p bg-e9e9e9 bor-9e9e9e p-5">{{ a.optionName }}</div>
            </div>
        </div>

        <div class="ml-30 w-80p bg-e9e9e9 pt-15 pb-15 pl-30 pr-30 mb-15">
            <div v-if="question.topicType != 4" class="mb-15">
                正确答案：{{ question.topicType == 5 ? answer[0].optionName : correct }}
            </div>
            <div class="flex jc-fs">解释说明：
                <div v-html="question.analysis"></div>
            </div>
        </div>

        <div class="line-h mb-15"></div>
    </div>
</template>

<script>
export default {
    name: 'qItem',
    components: {},
    props: {
        question: {
            type: Object,
            default() {
                return {};
            }
        },
        group: {
            type: Object,
            default() {
                return {};
            }
        },
        index: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: "edit"
        },
    },
    computed: {

    },
    data() {
        return {
            answer: [],
            correct: '',
        };
    },
    created() {
        this.answer = JSON.parse(this.question.answer);
        this.answer.forEach((item, i) => {
            if (item.isCorrect) {
                if (this.correct != '') {
                    this.correct = this.correct + '、';
                }
                this.correct = this.correct + item.optionName;
            }
        });
    },
    mounted() {
    },
    methods: {
        qDel(q) {
            let g = { ...this.group };
            const i = g.subQuestions.indexOf(q);
            if (i !== -1) {
                g.subQuestions.splice(i, 1);
                this.$emit("groupChange", g);
            }
        },
        qUp(q) {
            let g = { ...this.group };
            const index = g.subQuestions.indexOf(q);
            if (index > 0) {
                const temp = g.subQuestions[index - 1];
                g.subQuestions[index - 1] = g.subQuestions[index];
                g.subQuestions[index] = temp;
            }
            this.$emit("groupChange", g);
        },
        qDown(q) {
            let g = { ...this.group };
            const index = g.subQuestions.indexOf(q);
            if (index < g.subQuestions.length - 1) {
                const temp = g.subQuestions[index + 1];
                g.subQuestions[index + 1] = g.subQuestions[index];
                g.subQuestions[index] = temp;
            }
            this.$emit("groupChange", g);
        },
        scoreChange(e) {
            let g = { ...this.group };
            g.subQuestions[this.index].score = e;
            g.totalScore = 0;
            g.subQuestions.forEach((item) => {
                g.totalScore += item.score;
            });
            this.$emit("groupChange", g);
        },
    }
};
</script>

<style lang='scss' scoped>
.line-h {
    display: inline-block;
    height: 1px;
    width: 100%;
    background-color: #d8d8d8;
}

.q1 {
    width: 12px;
    height: 12px;
    border: 1px solid #e9e9e9;
    border-radius: 50%;
    margin-right: 5px;
}

.q2 {
    width: 14px;
    height: 14px;
    border: 1px solid #e9e9e9;
    border-radius: 3px;
    margin-right: 5px;
}

.q-no {
    font-size: 24px;
    color: #409eff;
}

i.disable {
    color: #ccc;
    border-color: #ccc;
}
</style>
